import React, { useImperativeHandle, useRef, useState } from "react";
import { RCCHTMLTextEditor, RCCModal, RCCRefModalProps } from "react-common-components";
import { useForm } from "react-hook-form";
import { useTranslation } from "src/context/Translations/context";
import { NotificationsType } from "src/pages/Config/Notifications/interface";
import { getMessageValue } from "src/pages/Config/Notifications/modals";
import { IComponentModalViewNotification, IRefModalViewNotification } from "./interface";

const ModalViewNotification: React.ForwardRefRenderFunction<IRefModalViewNotification, IComponentModalViewNotification> = ({
	onSubmit
}, ref) => {
	const { translate, currentLanguage } = useTranslation();

	const modalNotificationRef = useRef<RCCRefModalProps>(null);

	const messageId = useRef(0);
	const [buttonColor, setButtonColor] = useState("");
	const [titleState, setTitleState] = useState("");
	const [messageState, setMessageState] = useState("");
	const onCallbackFunction = useRef<Function>(() => {});

	const { control: controlAddOrChange  } = useForm();

	const openModalNotification = (type: number, title: string, message: string, id?: number, onCallback?: Function) => {
		setTitleState(title);
		setMessageState(message);
		setButtonColor(handleButtonColor(type));
		messageId.current = id ?? 0;
		if(onCallback)
			onCallbackFunction.current = () => onCallback();
		else
			onCallbackFunction.current = () => {};
		modalNotificationRef.current?.openModal();
	};

	const handleButtonColor = (type: number) => {

		switch (type) {
		case NotificationsType.SUCCESS:
			return "var(--green)";
		case NotificationsType.INFORMATION:
			return "var(--blue)";
		case NotificationsType.WARNING:
			return "var(--yellow)";
		case NotificationsType.ERROR:
			return "var(--red)";
		default:
			return "transparent";
		}
	};

	useImperativeHandle(ref, () => ({
		openModalNotification
	}));

	return (
		<RCCModal
			ref={modalNotificationRef}
			header={{
				title: getMessageValue(titleState, currentLanguage),
				icon: {
					name:  "infoCircle"
				}
			}}
			onClose={() => {
				if(!onSubmit)
					return;
				onSubmit(messageId.current);
				onCallbackFunction.current();
			}}
			footer={{
				buttonLoadingText: translate("Carregando"),
				saveButtonText: translate("Sim"),
				cancelButtonText: translate("Entendi"),
				showSaveButton: false
			}}
			styleInline={`
				width: 60vw;

				min-width: 300px;
				max-width: 800px;

				min-height: 400px;
				max-height: 90vh;
				height: max-content;
				overflow: hidden;

				>div:first-child{
					>button:last-child{
						display: none;
					}
				}
			
				>form{
					max-height: 90vh;
					div:last-child{
						
						button{
							background-color: ${buttonColor};
						}
					}
				}
			`}
		>
			<RCCHTMLTextEditor
				control={controlAddOrChange}
				name="messageState"
				label=""
				defaultValue={getMessageValue(messageState, currentLanguage)}
				disabled
				styleInline={`
					margin: 0;
					padding: 0;
					margin-bottom: 60px;
					
					.rdw-editor-toolbar{
						display: none;
					}
		
					.span-of-component-htmleditor{
						display: none;
					}
		
					.rdw-editor-main{
						border: none;
						cursor: unset;
					}
				`}
			/>
		</RCCModal>
	);
};

export default React.forwardRef(ModalViewNotification);

